// --- Dependencies -------------------------------------------------------------------------------
import { Link } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import useTranslation from "@/hooks/useTranslation";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
export default function NotFoundScreen() {
    const t = useTranslation();

    return (
        <main className="not-found">
            <h1 className="not-found__title">{t.screens.notFound}</h1>
            <Link className="not-found__link" to="/">
                {t.sideBar.home}
            </Link>
        </main>
    );
}
